module.exports = __webpack_public_path__ + "static/media/cart.37481457.svg";